module.exports = __webpack_public_path__ + "img/gc_country_flag_my.a7133020.svg";